module.exports = __webpack_public_path__ + "static/media/icon_3_2.00b2b359.svg";